const updateSelectedSnapDisplay = (emblaApi, snapDisplay) => {
  const selected = snapDisplay.querySelector(".c-embla-indexes__count");
  const total = snapDisplay.querySelector(".c-embla-indexes__total");
  const updateSnapDisplay = (emblaApi) => {
    const selectedSnap = emblaApi.selectedScrollSnap();
    const snapCount = emblaApi.scrollSnapList().length;
    if (selected) {
      selected.textContent = selectedSnap + 1;
    }
    if (total) {
      total.textContent = snapCount;
    }
  };
  emblaApi.on("select", updateSnapDisplay).on("reInit", updateSnapDisplay);
  updateSnapDisplay(emblaApi);
};

export { updateSelectedSnapDisplay };
